import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

const WalletTabs = ({ tabs = [], activeTab, onChange, className = '' }) => {
  return (
    <div className={`wallet-tabs ${className}`}>
      {tabs.map(tab => (
        <button
          key={tab.value}
          type="button"
          className={`wallet-tabs__item ${
            activeTab === tab.value ? 'wallet-tabs__item--active' : ''
          }`}
          onClick={() => onChange(tab.value)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

WalletTabs.propTypes = {
  tabs: PropTypes.arrayOf.isRequired,
  activeTab: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default WalletTabs;
